import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import { injectENV } from '../interface/env';
import type { ITranslationStorage } from '../interface/translationStorage';
import {
    bindTranslationStorage,
    injectTranslationStorage,
    unbindTranslationStorage,
} from '../interface/translationStorage';
import TYPES from '../util/types';
const loader = import('./translationstorage');

async function _build(container: IContainer): Promise<Readonly<ITranslationStorage>> {
    const env = injectENV(container);

    const module = await loader;

    return Object.freeze(module.default(env));
}

export default buildBindable<ITranslationStorage>({
    id: TYPES.ITranslationStorage,
    dependencies: [TYPES.IEnv],
    bind: bindTranslationStorage,
    remove: unbindTranslationStorage,
    inject: injectTranslationStorage,
    build: container => _build(container),
});
